// The explorer's URL search: the focus organisation number, the depth and the view, ids and codes only (docs/CONTRACTS.md
// section 5), so a link to a view can be shared and nothing typed ever reaches a URL. No imports, so the route entry
// (loaded with the shell) stays small; the screen loads as its own chunk.

export type View = 'focus' | 'overview'

export interface ExplorerSearch {
  /** 9-digit organisation number, kept as a number: the router writes a digits-only string quoted
   *  (focus=%22912345670%22) and a number bare (focus=912345670). Organisation numbers have no leading zero, so the
   *  number is exact. Absent = the server picks the default focus. */
  focus?: number
  /** 1 or 2; absent = 2 */
  hops?: 1
  /** absent = focus view */
  view?: 'overview'
}

/** Router validateSearch. Both the bare number and a quoted string are accepted; the result is the number. */
export function parseSearch(search: Record<string, unknown>): ExplorerSearch {
  const out: ExplorerSearch = {}
  const raw = typeof search.focus === 'number' ? String(search.focus) : search.focus
  if (typeof raw === 'string' && /^[1-9]\d{8}$/.test(raw)) out.focus = Number(raw)
  if (String(search.hops) === '1') out.hops = 1
  if (search.view === 'overview') out.view = 'overview'
  return out
}

/** The numbers the screen works with: depth 2 and the focus view unless the URL says otherwise. */
export function resolve(s: ExplorerSearch): { focus?: string; hops: 1 | 2; view: View } {
  return { focus: s.focus === undefined ? undefined : String(s.focus), hops: s.hops === 1 ? 1 : 2, view: s.view === 'overview' ? 'overview' : 'focus' }
}
